module.exports = __webpack_public_path__ + "static/travel-b66df0e6d499c0edb92f4fec80802cef.jpg";